function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.371,29.529s.335-2.012-1.731-4.469a42.818,42.818,0,0,0,2.29-10.778s4.133.95,4.133,5.026A12.66,12.66,0,0,1,23.371,29.529ZM11.979,27.078S9.211,18.195,9.211,14.51a20.871,20.871,0,0,1,.478-4.472H22.3a20.759,20.759,0,0,1,.481,4.473c0,3.629-2.76,12.567-2.76,12.567ZM15.99,12.069a2.569,2.569,0,1,0,2.569,2.569A2.569,2.569,0,0,0,15.99,12.069ZM15.438.6V-2.9h1V.507a15.741,15.741,0,0,1,5.635,8.575H9.913A15.629,15.629,0,0,1,15.438.6ZM8.629,29.529A12.657,12.657,0,0,1,3.938,19.308c0-4.076,4.133-5.026,4.133-5.026A42.841,42.841,0,0,0,10.36,25.06c-2.067,2.458-1.731,4.469-1.731,4.469Zm9.062.516-.838-.838L15.96,32,14.9,29.207l-.726,1.451L13.11,28.033h5.752l-1.171,2.012Z",
  transform: "translate(-3.938 2.902)",
  fill: "#28965a"
});

var SvgRocket = function SvgRocket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.125,
    height: 34.902,
    viewBox: "0 0 24.125 34.902",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRocket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rocket.3cb0f2b4.svg";
export { ForwardRef as ReactComponent };